<template>
  <div>
    <div class="zs_bjqk">
      <ul>
        <li>
          <div class="qkzp_bj bjqk_1"></div>
          <div class="zp_con">
            <div class="zcyj_1">{{ riverNum.normal }}</div>
            <div>已达标</div>
          </div>
        </li>
        <li>
          <div class="qkzp_bj bjqk_2"></div>
          <div class="zp_con">
            <div class="zcyj_2">{{ riverNum.out }}</div>
            <div>待改善</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    riverNum: {
      type: Object,
      default: () => {
        return {
          // total: 0,
          // cj: 0,
          // cs: 0,
          // yq: 0,
          // zf: 0,
          // wry: 0,
          // normal: 0,
          // alarm: 0,
          // offline: 0,
        };
      },
    },
  },
  data() {
    return {
      totalArr: ["0", "0", "0", "0", "0"],
    };
  },
  mounted() {
    this.splitTotal();
  },
  methods: {
    splitTotal() {
      let arr = [];
      let str = this.riverNum.total.toString();
      let zeroCount = 5 - str.length;
      for (let i = 0; i < zeroCount; i++) {
        arr.push("0");
      }
      for (let i = 0; i < str.length; i++) {
        let char = str.substring(i, i + 1);
        arr.push(char);
      }

      this.totalArr = arr;
    },
  },
  computed: {
    totalNum() {
      return this.riverNum.total;
    },
  },
  watch: {
    totalNum: function () {
      this.splitTotal();
    },
  },
};
</script>
<style lang="less" scoped>
@font-face {
  font-family: myFirstFont;
  src: url(../../../assets/fonts/DS-DIGIB.TTF);
}
* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
}

ul,
li,
span,
p,
h1,
h2,
h3,
h4,
h5,
h6,
a,
dl,
dt,
dd,
input {
  padding: 0;
  margin: 0;
  list-style: none;
  text-decoration: none;
  font-weight: normal;
  font-style: normal;
  font-family: "Microsoft yahei";
}
.zs_sl {
  width: 100%;
  height: 2.34vw;
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 0.5vw 0;
}
.zs_name {
  font-size: 1vw;
  color: rgba(255, 255, 255, 0.7);
}
.sz_ysa {
  font-size: 2vw;
  color: #00eaff;
  display: flex;
}
.sz_ysa p {
  width: 2vw;
  height: 2.35vw;
  background: url(../../../assets/map/tab_3.png) no-repeat;
  background-size: 100% 100%;
  text-align: center;
  line-height: 2.35vw;
  margin-left: 0.35vw;
  font-family: myFirstFont;
}
.zs_jtsz {
  width: 100%;
  height: 4.48vw;
  background: url(../../../assets/map/tab_4.png) no-repeat;
  background-size: 100% 100%;
  margin-top: 0.7vw 0;
}
.zs_jtsz ul {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;

  color: rgba(255, 255, 255, 0.9);
  padding: 0.5vw;
}
.zs_jtsz ul li {
  width: 30%;
  font-size: 0.75vw;
  line-height: 1.6vw;
  height: 1.6vw;
  position: relative;
  padding-left: 0.8vw;
  display: flex;
  align-items: center;
  white-space: nowrap;
  img {
    margin-right: 0.4vw;
    height: 0.9vw;
  }
}
.zs_jtsz ul li span {
  color: #00faf9;
}
.zs_bjqk {
  width: 100%;
  margin: 0.7vw 0;
}
.zs_bjqk ul {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
}
.zs_bjqk ul li {
  width: 5vw;
  height: 5vw;
  position: relative;
}
.qkzp_bj {
  width: 100%;
  height: 100%;
}
@keyframes xzyp {
  0% {
    transform: rotate(0);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.zs_bjqk ul li .bjqk_1 {
  background: url(../../../assets/map/river2.png) no-repeat;
  background-size: 100% 100%;
  animation: xzyp 10s linear infinite;
}
.zs_bjqk ul li .bjqk_2 {
  background: url(../../../assets/map/river1.png) no-repeat;
  background-size: 100% 100%;
  animation: xzyp 8s linear infinite;
}
.zs_bjqk ul li .bjqk_3 {
  background: url(../../../assets/map/tab_6.png) no-repeat;
  background-size: 100% 100%;
  animation: xzyp 10s linear infinite;
}

.zp_con {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  color: rgba(255, 255, 255, 0.9);
}
.zcyj_1 {
  color: #00fbfc;
  font-size: 1.2vw;
}
.zcyj_2 {
  color: #fab760;
  font-size: 1.2vw;
}
.zcyj_3 {
  color: #00acff;
  font-size: 1.2vw;
}
</style>